export default "__VITE_ASSET__oXjTwj9e__"